import React from 'react';
import Button from 'atomic/button';
import Icon from 'atomic/icon';

import './price-alert-modal-confirm.scss';

const PriceAlertModalConfirm: React.FC<{ onClose?: () => void; }> = ({ onClose }) => (
    <div className="price-alert-modal-confirm-content">
        <div className="price-alert-modal-confirm-content__icon">
            <Icon name="bell" size={40} color="primary" />
        </div>
        <div className="price-alert-modal-confirm-content__title">
            Jeszcze tylko potwierdzenie adresu
            {' '}
            <span>
                    e-mail.
            </span>
        </div>
        <div className="price-alert-modal-confirm-content__text">
            Sprawdź, czy otrzymałeś wiadomość e-mail z potwierdzeniem.
            Kliknij w zamieszczony w niej odnośnik, aby otrzymać alert cenowy.
        </div>
        <Button
            onClick={onClose}
            type="button"
            color="primary"
            size="lg"
            block={true}
            weight="500"
            className="price-alert-modal-confirm-content__button"
        >
            Wróć do strony produktu
        </Button>
    </div>
);

export default PriceAlertModalConfirm;
